var _path, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 42,
    viewBox: "0 0 84 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54545 11.394V8.89402H19V11.394H11.6818V32.1667H8.86364V11.394H1.54545ZM41.217 20.5304C41.217 22.9849 40.7739 25.1061 39.8875 26.894C39.0011 28.6819 37.7852 30.0607 36.2398 31.0304C34.6943 32.0001 32.9292 32.4849 30.9443 32.4849C28.9595 32.4849 27.1943 32.0001 25.6489 31.0304C24.1034 30.0607 22.8875 28.6819 22.0011 26.894C21.1148 25.1061 20.6716 22.9849 20.6716 20.5304C20.6716 18.0758 21.1148 15.9546 22.0011 14.1667C22.8875 12.3789 24.1034 11.0001 25.6489 10.0304C27.1943 9.06069 28.9595 8.57584 30.9443 8.57584C32.9292 8.57584 34.6943 9.06069 36.2398 10.0304C37.7852 11.0001 39.0011 12.3789 39.8875 14.1667C40.7739 15.9546 41.217 18.0758 41.217 20.5304ZM38.4898 20.5304C38.4898 18.5152 38.1527 16.8145 37.4784 15.4281C36.8117 14.0417 35.9064 12.9925 34.7625 12.2804C33.6261 11.5683 32.3534 11.2122 30.9443 11.2122C29.5352 11.2122 28.2587 11.5683 27.1148 12.2804C25.9784 12.9925 25.0731 14.0417 24.3989 15.4281C23.7322 16.8145 23.3989 18.5152 23.3989 20.5304C23.3989 22.5455 23.7322 24.2463 24.3989 25.6327C25.0731 27.019 25.9784 28.0683 27.1148 28.7804C28.2587 29.4925 29.5352 29.8486 30.9443 29.8486C32.3534 29.8486 33.6261 29.4925 34.7625 28.7804C35.9064 28.0683 36.8117 27.019 37.4784 25.6327C38.1527 24.2463 38.4898 22.5455 38.4898 20.5304ZM45.1557 32.1667V8.89402H59.1102V11.394H47.9739V19.2577H58.0648V21.7577H47.9739V32.1667H45.1557Z",
    fill: "#23AF91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_464_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4219 11C67.4219 10.4477 67.8696 10 68.4219 10H72.4184C72.9707 10 73.4184 10.4477 73.4184 11V14.9965C73.4184 15.5488 72.9707 15.9965 72.4184 15.9965H68.4219C67.8696 15.9965 67.4219 15.5488 67.4219 14.9965V11Z",
    fill: "#23AF91"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_464_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4219 19.0014C67.4219 18.4491 67.8696 18.0014 68.4219 18.0014H72.4184C72.9707 18.0014 73.4184 18.4491 73.4184 19.0014V22.9979C73.4184 23.5502 72.9707 23.9979 72.4184 23.9979H68.4219C67.8696 23.9979 67.4219 23.5502 67.4219 22.9979V19.0014Z",
    fill: "#8E7CFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_464_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4219 27.0027C67.4219 26.4505 67.8696 26.0027 68.4219 26.0027H72.4184C72.9707 26.0027 73.4184 26.4505 73.4184 27.0027V30.9993C73.4184 31.5516 72.9707 31.9993 72.4184 31.9993H68.4219C67.8696 31.9993 67.4219 31.5516 67.4219 30.9993V27.0027Z",
    fill: "#FF5E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_464_270",
    x: 57.4219,
    y: 0,
    width: 25.9961,
    height: 25.9965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.686275 0 0 0 0 0.568627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_464_270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_464_270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_464_270",
    x: 57.4219,
    y: 8.0014,
    width: 25.9961,
    height: 25.9965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_464_270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_464_270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_464_270",
    x: 57.4219,
    y: 16.0027,
    width: 25.9961,
    height: 25.9965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.4 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_464_270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_464_270",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu_logo.7afcb2d51950eb7bfaf84f57219fd17e.svg";
export { ForwardRef as ReactComponent };